export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAABHAQMAAAD4L2+GAAAAA1BMVEX///+nxBvIAAAAC0lEQVQIHWMYVAAAAI4AAYU8iRgAAAAASUVORK5CYII="